/**
 * Checks if a string contains any alphabetic characters
 */
export function hasLetters(str: string): boolean {
    return /[a-zA-Z]/.test(str);
}
